<template>
  <PortalPage
    :esg-data="esgData"
    :forecast-data="forecastData"
    :price-data="priceData"
    :general="general"
  />
</template>

<script setup lang="ts">
import PortalPage from '~/components/shared/price-assessments/PortalPage.vue'

import { BLACK_MASS, MARKET } from '~/constants/services/constants'
import { PRICE_ASSESSMENTS_BLACK_MASS } from '~/constants/services/price-assessments'
import { FORECASTS_RECYCLING } from '~/constants/services/forecasts'
import recyclingPortalData from '~/constants/portal/recycling'
import { MARKET_SLUG } from '~/src/constants/markets'

import { capitalize } from '~/utils/string'

/*-------------------------------------
  Constants
-------------------------------------*/
const general = {
  ...BLACK_MASS,
  ...recyclingPortalData,
  slug: BLACK_MASS.reportSlug,
  title: capitalize(MARKET_SLUG.RECYCLING),
  icon: BLACK_MASS.iconColor,
  categoryAnalysis: BLACK_MASS.slug,
  hideSustainabilityIndex: true,
}

const esgData = {
  sustainabilityIndexes: [],
}

const forecastData = FORECASTS_RECYCLING
const priceData = PRICE_ASSESSMENTS_BLACK_MASS

/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({ layout: 'services' })

/*-------------------------------------
  SEO
-------------------------------------*/
const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${BLACK_MASS.name} Portal`,
})
useHead(seo)
</script>
